<template>
  <InsideContent
    :title="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_TITLE')"
    :description="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_DESCRIPTION')"
  >
    <ElButton
      native-type="button"
      type="primary"
      icon="el-icon-edit"
      @click.native="openModal('showEditCampaignDailyCapModal')"
    >
      {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_DAILY_CAP') }}
    </ElButton>
    <CardApiError
      v-if="apiError"
      :loading="isLoading"
      @retry="getCampaignDailyCap"
    />
    <BudgetInfo
      v-else
      :loading="isLoading"
      :title="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_TITLE')"
      :no-credit-text="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.WITHOUT_DAILY_CAP')"
      :credit="dailyCap"
    />
    <EditCampaignDailyCapModal
      v-model="showEditCampaignDailyCapModal"
      :default-daily-cap="dailyCap"
      @changed="getCampaignDailyCap"
    />
  </InsideContent>
</template>

<script>
import EditCampaignDailyCapModal from './EditCampaignDailyCapModal';
import BudgetInfo from '@@/common/BudgetInfo';

import InsideContent from '@@/common/layout/InsideContent';
import CardApiError from '@@/common/CardApiError';

import { AdCampaignFinance } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';

import modal from '@/mixins/modal';

export default {
  name: 'CampaignDailyCap',
  components: {
    EditCampaignDailyCapModal,
    BudgetInfo,
    InsideContent,
    CardApiError,
  },
  mixins: [modal, campaignId],
  data() {
    return {
      showEditCampaignDailyCapModal: false,

      dailyCap: 0,

      isLoading: false,
      apiError: false,
    };
  },
  mounted() {
    this.getCampaignDailyCap();
  },
  methods: {
    getCampaignDailyCap() {
      this.isLoading = true;
      this.apiError = false;
      return AdCampaignFinance.getCampaignDailyCap({
        itemId: this.campaignId,
      })
        .then(({ body: { daily_cap: dailyCap } }) => {
          if (!dailyCap) this.dailyCap = 0;
          else this.dailyCap = dailyCap;
        })
        .catch(() => {
          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
